module.exports = __webpack_public_path__ + "static/img/6a735e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/4.png
// module id = 624
// module chunks = 2